module.exports = __webpack_public_path__ + "static/media/Azure-Cosmos-Logo.7aae285d.png";